import { useEffect } from "react";
import { Provider, useDispatch } from "react-redux";
import store from "../../store";
import { setAccountSlug } from "../../slices";
import SowHeader from "./SowHeader";

/* Seeds the slug slice so RTK Query hooks inside SowHeader have
 an accountSlug even though this component is mounted outside of App.js. */
const SowHeaderInner = (props) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (props.account_slug) {
      dispatch(setAccountSlug(props.account_slug));
    }
  }, [props.account_slug]);

  return <SowHeader {...props} />;
};

const SowHeaderWithProvider = (props) => (
  <Provider store={store}>
    <SowHeaderInner {...props} />
  </Provider>
);

export default SowHeaderWithProvider;
